<div class=" mt-4">
    <section>
        <div class="row">
            <div class="col-md-10">
                <div class="float-right">
                    <!-- <button class="btn dash-btns mr-3" [routerLink]="['/pos/item/manage']">Manage Item Details</button>

                    <button class="btn dash-btns" [routerLink]="['/pos/item/new']">New Items</button> -->

                </div>
            </div>
        </div>

    </section>
    <section class="mt-3">
        <div class="">
            <div class="row">
                <div class="col-md-8 offset-md-2">
                    <div class="card-1">
                        <div class="row">
                            <div class="col-md-12">
                                <!-- <div class="text-center mb-5">
                                    <img src="assets/img/new/view-trans.svg" />
                                </div> -->
                                <div class="text-center">
                                    <a class="view-h gary-t"> View Items</a>
                                </div>

                                <div class="pt-3">
                                    <div>
                                        <div class="row mb-3">
                                            <div class="col-4 p-0 label1">Item Name</div>

                                            <div class="col-7 view-text"> {{rows.Name}}</div>
                                        </div>
                                        <div class="row mb-3">
                                            <div class="col-4 p-0 label1">Category Name</div>

                                            <div class="col-7 view-text"> {{categoryName}}</div>
                                        </div>
                                        
                                        <div class="row mb-3">
                                            <div class="col-4 p-0 label1">Alternative Item Name</div>

                                            <div class="col-7 view-text"> {{rows.AlternativeName}}</div>
                                        </div>                                  
                                        <div class="row mb-3">
                                            <div class="col-4 p-0 label1"> Price </div>

                                            <div class="col-7 view-text"> {{ rows.Price }}</div>
                                        </div>

                                        <div class="row mb-3">
                                            <div class="col-4 p-0 label1">Price Type</div>

                                            <!-- <div class="col-7 view-text"> {{rows.priceType}}</div> -->
                                            <div class="col-7 view-text"> {{PriceType}}</div>

                                        </div>

                                        <div class="row mb-3">
                                            <div class="col-4 p-0 label1">Sku</div>

                                            <div class="col-7 view-text"> {{rows.Sku}}</div>
                                        </div>
                                        <div class="row mb-3">
                                            <div class="col-4 p-0 label1">Tax Fee</div>

                                            <div class="col-7 view-text"> {{rows.TaxFeeId}}</div>
                                        </div>
                                        <div class="row mb-3">
                                            <div class="col-4 p-0 label1">Date Time</div>

                                            <div class="col-7 view-text"> {{rows.DateTime | date:'d/M/yy, h:mm a'}}
                                            </div>
                                        </div>
                                        <div class="row mb-3">
                                            <div class="col-4 p-0 label1">Product Code</div>

                                            <div class="col-7 view-text"> {{rows.ProductCode}}</div>
                                        </div>
                                        <div class="row mb-3">
                                            <div class="col-4 p-0 label1">Bar Code</div>

                                            <div class="col-7 view-text"> {{rows.BarCode}}</div>
                                        </div>
                                        <div class="row mb-3">
                                            <div class="col-4 p-0 label1">HSN Code </div>

                                            <div class="col-7 view-text"> {{rows.HsnCode}}</div>
                                        </div>
                                        <div class="row mb-3">
                                            <div class="col-4 p-0 label1">Item Image </div>

                                            <div class="col-7 view-text" *ngIf="Imageavalabel">

                                                <img [ngStyle]="{'width': maxWidth+'px', 'height': maxHeight+'px'}"
                                                    src="data:image/jpeg;base64,{{content}}" fxFlexAlign="center"
                                                    id="merchatImage"
                                                    class="fade-in-on-icon-sidenav img-thumbnail img-rounded">

                                            </div>
                                            <div class="col-7 view-text" *ngIf="noImageavalabel">

                                                <img [ngStyle]="{'width': maxWidth+'px', 'height': maxHeight+'px'}"
                                                    src="assets/img/no-preview.png" fxFlexAlign="center"
                                                    id="merchatImage"
                                                    class="fade-in-on-icon-sidenav img-thumbnail img-rounded">

                                            </div>
                                            <div class="col-7 view-text" *ngIf="Imageavalabel1">

                                                <img [ngStyle]="{'width': maxWidth+'px', 'height': maxHeight+'px'}"
                                                    [src]=imageurl fxFlexAlign="center"
                                                    id="merchatImage"
                                                    class="fade-in-on-icon-sidenav img-thumbnail img-rounded">

                                            </div>
                                            <div class="col-7 view-text" *ngIf="noImageavalabel1">

                                                <img [ngStyle]="{'width': maxWidth+'px', 'height': maxHeight+'px'}"
                                                    [src]=imageurl fxFlexAlign="center"
                                                    id="merchatImage"
                                                    class="fade-in-on-icon-sidenav img-thumbnail img-rounded">

                                            </div>

                                        </div>
                                        <div class="text-right py-2">
                                            <button class="btn dash-btns mr-3" [routerLink]="['/pos/item/manage']">Back</button>                           
                                                        </div>                                                            
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </section>
</div>